import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export function splitWords(el) {
    if (!el || el.dataset.split === "true") return el;
    const text = el.textContent;
    el.textContent = "";
    text.split(/(\s+)/).forEach((w) => {
        if (w.trim() === "") { el.appendChild(document.createTextNode(w)); return; }
        const wrap = document.createElement("span");
        wrap.className = "ps-split-word";
        const inner = document.createElement("span");
        inner.textContent = w;
        wrap.appendChild(inner);
        el.appendChild(wrap);
    });
    el.dataset.split = "true";
    return el;
}

export function initScrollAnimations() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return () => {};
    const ctx = gsap.context(() => {
        document.querySelectorAll("[data-split]").forEach(splitWords);
        gsap.to("[data-hero-title] .ps-split-word > span", {
            y: 0, duration: 1.1, ease: "power3.out", stagger: 0.06, delay: 0.2,
        });
        gsap.to("[data-hero-fade]", {
            opacity: 1, y: 0, duration: 1, ease: "power2.out", stagger: 0.1, delay: 0.5,
        });
        gsap.utils.toArray(".ps-fade").forEach((el) => {
            gsap.to(el, {
                opacity: 1, y: 0, duration: 1, ease: "power3.out",
                scrollTrigger: { trigger: el, start: "top 85%", toggleActions: "play none none reverse" },
            });
        });
        gsap.utils.toArray("[data-split-scroll]").forEach((el) => {
            const spans = el.querySelectorAll(".ps-split-word > span");
            gsap.set(spans, { y: "110%" });
            gsap.to(spans, {
                y: 0, duration: 0.9, ease: "power3.out", stagger: 0.04,
                scrollTrigger: { trigger: el, start: "top 80%", toggleActions: "play none none reverse" },
            });
        });
        gsap.utils.toArray("[data-service]").forEach((el, i) => {
            gsap.from(el, {
                opacity: 0, y: 40, duration: 0.9, ease: "power3.out", delay: i * 0.03,
                scrollTrigger: { trigger: el, start: "top 88%", toggleActions: "play none none reverse" },
            });
        });
        gsap.utils.toArray("[data-project]").forEach((el) => {
            gsap.from(el, {
                opacity: 0, y: 60, duration: 1.1, ease: "power3.out",
                scrollTrigger: { trigger: el, start: "top 82%", toggleActions: "play none none reverse" },
            });
        });
    });
    return () => { ctx.revert(); ScrollTrigger.getAll().forEach((t) => t.kill()); };
}

export function bindTilt(el, options = {}) {
    const maxTilt = options.max ?? 8;
    let raf = 0, rx = 0, ry = 0, tRx = 0, tRy = 0;
    function onMove(e) {
        const rect = el.getBoundingClientRect();
        const x = (e.clientX - rect.left) / rect.width - 0.5;
        const y = (e.clientY - rect.top) / rect.height - 0.5;
        tRy = x * maxTilt; tRx = -y * maxTilt;
        if (!raf) raf = requestAnimationFrame(update);
    }
    function onLeave() { tRx = 0; tRy = 0; }
    function update() {
        rx += (tRx - rx) * 0.12; ry += (tRy - ry) * 0.12;
        el.style.transform = `perspective(900px) rotateX(${rx}deg) rotateY(${ry}deg)`;
        if (Math.abs(tRx - rx) > 0.01 || Math.abs(tRy - ry) > 0.01) {
            raf = requestAnimationFrame(update);
        } else { raf = 0; }
    }
    el.addEventListener("mousemove", onMove);
    el.addEventListener("mouseleave", onLeave);
    return () => {
        el.removeEventListener("mousemove", onMove);
        el.removeEventListener("mouseleave", onLeave);
        cancelAnimationFrame(raf); el.style.transform = "";
    };
}
